import { api } from "@/services/api";

var BUILT_IN_ITEMS = require("@/components/Menu/QuickAccessItems").BUILT_IN_ITEMS;

var state = {
  favourites: [],
  loading: false,
  loaded: false,
};

var getters = {
  favouritesList: function (state) {
    return state.favourites;
  },
  favouriteKeys: function (state) {
    return state.favourites.map(function (f) { return f.module_key; });
  },
  isFavourite: function (state) {
    return function (moduleKey) {
      return state.favourites.some(function (f) { return f.module_key === moduleKey; });
    };
  },
  isLoading: function (state) {
    return state.loading;
  },
};

var mutations = {
  SET_FAVOURITES: function (state, favourites) {
    state.favourites = favourites;
    state.loaded = true;
  },
  SET_LOADING: function (state, val) {
    state.loading = val;
  },
  ADD_FAVOURITE: function (state, fav) {
    state.favourites.push(fav);
  },
  REMOVE_FAVOURITE: function (state, moduleKey) {
    state.favourites = state.favourites.filter(function (f) {
      return f.module_key !== moduleKey;
    });
  },
  REORDER_FAVOURITES: function (state, orderedKeys) {
    var map = {};
    state.favourites.forEach(function (f) { map[f.module_key] = f; });
    state.favourites = orderedKeys.map(function (key) { return map[key]; }).filter(Boolean);
  },
};

var actions = {
  fetchFavourites: function (context) {
    var userId = localStorage.getItem("USER_ID");
    var entityId = localStorage.getItem("ENTITY_ID");
    if (!userId || !entityId) return Promise.resolve();

    context.commit("SET_LOADING", true);
    // validateStatus: () => true prevents 401/403 response interceptors from
    // triggering a full logout for this background best-effort call.
    return api.get("/quick_access_favourites/" + userId + "/" + entityId, { validateStatus: function() { return true; } })
      .then(function (res) {
        if (res.status === 200) {
          context.commit("SET_FAVOURITES", (res.data && res.data.data) || []);
        }
        // For any non-200 (401, 403, 500, etc.) just leave favourites empty — never log out.
      })
      .catch(function (e) {
        console.error("Failed to fetch quick access favourites:", e);
        context.commit("SET_FAVOURITES", []);
      })
      .finally(function () {
        context.commit("SET_LOADING", false);
      });
  },

  addFavourite: function (context, item) {
    var userId = parseInt(localStorage.getItem("USER_ID"));
    var entityId = parseInt(localStorage.getItem("ENTITY_ID"));
    if (!userId || !entityId) return Promise.resolve();

    return api.post("/quick_access_favourites/add", {
      favourite: {
        user_id: userId,
        entity_id: entityId,
        module_key: item.key,
        module_name: item.name,
        module_route: item.route,
        module_icon: item.icon || "",
        module_category: item.category || "",
      },
    })
    .then(function (res) {
      if (res.data && res.data.status === "success") {
        context.commit("ADD_FAVOURITE", res.data.data);
      }
    })
    .catch(function (e) {
      console.error("Failed to add favourite:", e);
    });
  },

  removeFavourite: function (context, moduleKey) {
    var userId = localStorage.getItem("USER_ID");
    var entityId = localStorage.getItem("ENTITY_ID");
    if (!userId || !entityId) return Promise.resolve();

    context.commit("REMOVE_FAVOURITE", moduleKey);
    return api.delete("/quick_access_favourites/remove/" + userId + "/" + entityId + "/" + moduleKey)
      .catch(function (e) {
        console.error("Failed to remove favourite:", e);
        // Re-fetch to sync state
        context.dispatch("fetchFavourites");
      });
  },

  reorderFavourites: function (context, orderedKeys) {
    var userId = parseInt(localStorage.getItem("USER_ID"));
    var entityId = parseInt(localStorage.getItem("ENTITY_ID"));
    if (!userId || !entityId) return Promise.resolve();

    context.commit("REORDER_FAVOURITES", orderedKeys);
    return api.put("/quick_access_favourites/reorder", {
      user_id: userId,
      entity_id: entityId,
      ordered_keys: orderedKeys,
    })
    .catch(function (e) {
      console.error("Failed to reorder favourites:", e);
    });
  },

  initializeDefaults: function (context) {
    if (context.state.loaded && context.state.favourites.length === 0) {
      var userId = parseInt(localStorage.getItem("USER_ID"));
      var entityId = parseInt(localStorage.getItem("ENTITY_ID"));
      if (!userId || !entityId) return Promise.resolve();

      var favourites = BUILT_IN_ITEMS.map(function (item, index) {
        return {
          module_key: item.key,
          module_name: item.name,
          module_route: item.route,
          module_icon: item.icon || "",
          module_category: item.category || "",
          sort_order: index,
        };
      });

      return api.post("/quick_access_favourites/save", {
        user_id: userId,
        entity_id: entityId,
        favourites: favourites,
      }, { validateStatus: function() { return true; } })
      .then(function (res) {
        if (res.status === 200 || res.status === 201) {
          return context.dispatch("fetchFavourites");
        }
        // Non-200 responses are silently ignored — defaults remain empty
      })
      .catch(function (e) {
        console.error("Failed to initialize default favourites:", e);
      });
    }
    return Promise.resolve();
  },
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
